// extracted by mini-css-extract-plugin
export default {"card":"_-_-record-it-components-src-card-CardStandard-__card"};